import { apiClient } from '../../utils/apiClient';

const sessionKey = (key: string, version: number) => `dd_tour_dismissed:${key}:${version}`;

/**
 * Within-session guard so a POST still in flight during a fast navigation
 * can't let the tour re-show. The server row is the source of truth; this is
 * only the fast path, and every access is guarded because private browsing
 * can make sessionStorage throw.
 */
export function markDismissedLocally(key: string, version: number): void {
  try {
    window.sessionStorage.setItem(sessionKey(key, version), '1');
  } catch {
    // no-op
  }
}

export function isDismissedLocally(key: string, version: number): boolean {
  try {
    return window.sessionStorage.getItem(sessionKey(key, version)) === '1';
  } catch {
    return false;
  }
}

/**
 * Fire-and-forget. The caller hides the tour first and never waits on this: a
 * failed POST must not trap the user in a tour. The endpoint is idempotent, so
 * the next page load simply tries again.
 */
export function dismissTour(
  key: string,
  version: number,
  dismissalType: 'completed' | 'skipped',
): void {
  markDismissedLocally(key, version);
  apiClient
    .post('/user_tours/dismiss', {
      tour_key: key,
      tour_version: version,
      dismissal_type: dismissalType,
    })
    .catch(() => {
      // Swallowed deliberately — retried on the next visit.
    });
}
